//
export default {
    computed: {
        /**
         *
         */
        dialogProps() {
            return {
                contentClass: this.contentClass,
                fullscreen: this.width < 1,
                transition: this.transition,
                width: this.width,
            }
        },

        /**
         *
         */
        transition() {
            return this.width > 0
                ? 'scale-transition'
                : 'dialog-bottom-transition'
        },
    },
    methods: {
        /**
         *
         */
        close() {
            this.$emit('input', false)
        },

        /**
         *
         */
        submit() {
            this.$emit('submit')
        },
    },
    props: {
        /**
         *
         */
        contentClass: {
            type: [String, Object],
            default: () => ({}),
        },

        /**
         *
         */
        noConfirm: Boolean,

        /**
         *
         */
        submitIcon: {
            type: String,
            default: 'done_all',
        },

        /**
         *
         */
        submitText: {
            type: String,
            default: 'confirmar',
        },

        /**
         *
         */
        title: String,

        /**
         *
         */
        value: Boolean,

        /**
         *
         */
        width: {
            type: Number,
            default: 0,
        },
    },
}
